import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { appConstants } from "../../../_constants";
import { http, util } from "../../../_helpers";
//import { AdminSubscriptions } from './index';
import { format } from "date-fns";
const { string } = util;

export * from "./show";
export * from "./edit";
declare var $: any;
let fetching = false;
let tab: any = null;
export const AdminSubscriptions = () => {
  const navigate = useNavigate();
  const ref = useRef(null);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<any[]>([]);


  const getItems = () => {
    if (fetching) return;
    fetching = true;

    http.get("/companies/admin/subscriptions/list").then((res) => {
      if (Array.isArray(res?.data)) {
        setItems(res.data);
        setTimeout(() => {
          if (($ as any).fn.DataTable.isDataTable($(ref.current) as any)) {
            if (tab) {
              tab.clear();
              tab.destroy();
            }
            $(ref.current).empty();
          }
          tab = ($(ref.current) as any).DataTable(
            appConstants.dataTableSettings
          );
        }, 400);
      }
      setLoading(false);
      fetching = false;
    });
  };

  const onShow = (state: any) => {
    navigate("show", { state });
  };

  const onStatus = async (state: any) => {
    const superadmin = await util.amIAdmin();
    if(!superadmin){ 
      alert("L'administrateur doit être un super administrateur pour pouvoir modifier le statut de l'abonnement!");
      return;
    }
    const active = state.active == "1" ? "0" : "1";
    if (active == "0") {
      if (
        !window.confirm(
          `Attention ! vous êtes sur le point de désactiver l'abonnement ${state.plan} de ${state.companyName}. Ce compte n'aura plus accès aux avantages de PRO.`
        )
      ) {
        return;
      }
    }
    setLoading(true);
    const res = await http.patch(
      encodeURI(`/companies/admin/subscriptions/update`),
      { ...state, active }
    );
    if (res.code === 200) {
      window.location.reload();
    } else {
      alert("Une erreur est survenue ! Merci de reéssayer.");
      setLoading(false);
    }
  };




  const onEdit = async (state: any) => {
    const superadmin = await util.amIAdmin();
    if(!superadmin){ 
      alert("L'administrateur doit être un super administrateur pour pouvoir modifier la durée  de l'abonnement!");
      return;
    }
    navigate("edit", { state });
  };

  const onDelete = async (state: any) => {
    const superadmin = await util.amIAdmin();
    if(!superadmin){ 
      alert("L'administrateur doit être un super administrateur pour pouvoir supprimer l'abonnement!");
      return;
    }
    let v = window.confirm(
      ` Attention vous êtes sur le point de supprimer l'abonnement de  ${state.companyName}. Cette action est irreversible !`
    );
    if (v) {
      setLoading(true);
      console.log("HEYYYY",state);
      await http.remove(encodeURI(`/subscriptions/admin/remove/${state.id}`));
      getItems();
    }
  };

  useEffect(() => {
    getItems();

    return () => {
      if (($ as any).fn.DataTable.isDataTable($(ref.current) as any)) {
        if (tab) {
          tab.clear();
          tab.destroy();
        }
        $(ref.current).empty();
      }
    };
  }, []);
  return (
    <div>
      <h4 className="text-muted mb-4">Gestion des abonnements</h4>
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card border-0 rounded-0">
            <div className="card-title mb-1 p-3">
              {!loading && <h5>Liste des abonnements</h5>}
              {loading && <h5 className="text-muted">Chargement en cours</h5>}
            </div>
            <div className="card-body">
              {!loading && (
                <div className="table-responsive-md">
                  <table
                    id="admin_table"
                    ref={ref}
                    className="table table-hover"
                  >
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Forfait</th>
                        <th scope="col">Companie</th>
                        <th scope="col">Etat</th>
                        <th scope="col">Début</th>
                        <th scope="col">Fin</th>
                        <th scope="col">Montant</th>
                        <th scope="col">Paiement</th>
                        <th scope="col">Statut</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, i) => {
                        return (
                          <tr key={i}>
                            <th scope="row">{i + 1}</th>
                            <td>{string(item.plan)}</td>
                            <td>{string(item.companyName)}</td>
                            <td>{string(item.status)}</td>
                            <td>{string(item.startDate)}</td>
                            <td>{string(item.endDate)}</td>
                            <td>{string(item.amount)}</td>
                            <td>{string(item.paymentStatus)}</td>

                            <td className="text-center">
                              {item.active == "1" && (
                                <i
                                  className="fa fa-check text-success"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onStatus(item)}
                                ></i>
                              )}
                              {item.active == "0" && (
                                <i
                                  className="fa fa-times text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onStatus(item)}
                                ></i>
                              )}
                            </td>
                            
                            <td>
                              <a
                                className="btn btn-sm btn-outline-lightning rounded-0 mr-2 "
                                onClick={() => onShow(item)}
                              >
                                <i className="fa fa-eye"></i>
                              </a>
                              <a
                                className="btn btn-sm btn-outline-lightning rounded-0 mr-2 "
                                onClick={() => onEdit(item)}
                              >
                                <i className="far fa-edit"></i>
                              </a>
                              {['INITIATED', 'FAILED', 'EXPIRED'].includes(item.paymentStatus) && item.status !== "ACTIVE" && item.active == "0" && (
                                <a
                                  className="btn btn-sm btn-outline-lightning rounded-0"
                                  onClick={() => onDelete(item)}
                                >
                                  <i className="far fa-trash-alt"></i>
                                </a>
                              )}
                      

                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
